import { render, staticRenderFns } from "./Docspiece.vue?vue&type=template&id=6e22721d&scoped=true"
import script from "./Docspiece.vue?vue&type=script&lang=js"
export * from "./Docspiece.vue?vue&type=script&lang=js"
import style0 from "./Docspiece.vue?vue&type=style&index=0&id=6e22721d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22721d",
  null
  
)

export default component.exports